<!--
 * @Description:
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-24 09:41:24
 * @LastEditors: lau
 * @LastEditTime: 2022-08-24 09:50:20
-->
<!-- 获取单个停车场空车位接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode":"2KNTYVWC",
                "remainCarportList":[{
                  "areaId":1,
                  "totalRemain":1,
                  "tempRemain":1,
                  "fixedRemain":1
                },{
                  "areaId":1,
                  "totalRemain":1,
                  "tempRemain":1,
                  "fixedRemain":1
                }]
            },
            responseCode: {
                "data": {},
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台根据车场UUID 测算的收费标准自增ID以及之前返回的查费信息对象获取当前收费标准的测算结果",
                t_url: this.commonUrls.test+"getParkYdtOtherCarTypeChargeInfo",
                p_url: this.commonUrls.prod+"getParkYdtOtherCarTypeChargeInfo",
                precondition: "无",
                fitSystem: "云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'standardSeq', info2: '是', info3: 'Integer', info4: '收费标准id' },
                        { info1: 'carType', info2: '是', info3: 'Integer', info4: '计费规则的车辆类型' },
                        { info1: 'startTime', info2: '是', info3: 'String', info4: '计费开始时间（yyyy-MM-dd HH:mm:ss），用于计算出计费开始时间的1小时，2小时，3小时，4小时，8小时各个时段的费用' },
                        { info1: 'parkYdtChargeVo', info2: '是', info3: 'JSONObject', info4: '调用getParkYdtCharge接口得到的返回结果' },
                        ]
                },
                {
                    titleName: 'parkYdtChargeVo',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'chargeTypeSeq', info2: '否', info3: 'Integer', info4: '收费规则组ID' },
                        { info1: 'parkSysType', info2: '否', info3: 'Integer', info4: '停车场类型 0 VEMS 1 云车场' },
                        { info1: 'carType', info2: '否', info3: 'Boolean', info4: '是否区分车辆类型(false不区分，true区分)' },
                        { info1: 'workDay', info2: '否', info3: 'Boolean', info4: '是否区分工作日(false不区分，true区分)' },
                        { info1: 'parkYdtChargeStandardVoList', info2: '否', info3: 'JSONArray', info4: '收费规则信息列表' }
                        ]
                },{
                    titleName: 'parkYdtChargeStandardVoList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'standardSeq', info2: '否', info3: 'Integer', info4: '收费规则标准id' },
                        { info1: 'type', info2: '否', info3: 'Integer', info4: '收费规则标准类型（0自定义，1免费规则，2循环递增，3按次固定） VEMS没有 设置为0 或者VEMS没开启计费服务 则是设置为免费' },
                        { info1: 'carType', info2: '否', info3: 'Integer', info4: '车辆类型' },
                        { info1: 'carTypeName', info2: '否', info3: 'String', info4: '车辆类型名称 如果是区分车型 就会有值' },
                        { info1: 'freeTime', info2: '否', info3: 'Integer', info4: '免费时长 多少分钟内免费' },
                        { info1: 'maxCharge', info2: '否', info3: 'Decimal', info4: '24小时封顶金额' },
                        { info1: 'customMaxUnit', info2: '否', info3: 'Integer', info4: '自定义封顶时长，时长<1440分钟' },
                        { info1: 'customMaxCharge', info2: '否', info3: 'Decimal', info4: '自定义封顶时长对应金额' },
                        { info1: 'chargeMap', info2: '否', info3: 'JSONArray', info4: '查费结果' },


                        ]
                }
                ],
                R_params: [ {
                  titleName: '',
                  tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                  td: [
                    { info1: 'chargeTypeSeq', info2: '否', info3: 'Integer', info4: '收费规则组ID' },
                    { info1: 'parkSysType', info2: '否', info3: 'Integer', info4: '停车场类型 0 VEMS 1 云车场' },
                    { info1: 'carType', info2: '否', info3: 'Boolean', info4: '是否区分车辆类型(false不区分，true区分)' },
                    { info1: 'workDay', info2: '否', info3: 'Boolean', info4: '是否区分工作日(false不区分，true区分)' },
                    { info1: 'parkYdtChargeStandardVoList', info2: '否', info3: 'JSONArray', info4: '收费规则信息列表' }
                  ]
                },{
                  titleName: 'parkYdtChargeStandardVoList',
                  tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                  td: [
                    { info1: 'standardSeq', info2: '否', info3: 'Integer', info4: '收费规则标准id' },
                    { info1: 'type', info2: '否', info3: 'Integer', info4: '收费规则标准类型（0自定义，1免费规则，2循环递增，3按次固定） VEMS没有 设置为0 或者VEMS没开启计费服务 则是设置为免费' },
                    { info1: 'carType', info2: '否', info3: 'Integer', info4: '车辆类型' },
                    { info1: 'carTypeName', info2: '否', info3: 'String', info4: '车辆类型名称 如果是区分车型 就会有值' },
                    { info1: 'freeTime', info2: '否', info3: 'Integer', info4: '免费时长 多少分钟内免费' },
                    { info1: 'maxCharge', info2: '否', info3: 'Decimal', info4: '24小时封顶金额' },
                    { info1: 'customMaxUnit', info2: '否', info3: 'Integer', info4: '自定义封顶时长，时长<1440分钟' },
                    { info1: 'customMaxCharge', info2: '否', info3: 'Decimal', info4: '自定义封顶时长对应金额' },
                    { info1: 'chargeMap', info2: '否', info3: 'JSONArray', info4: '查费结果' },


                  ]
                },{
                  titleName: 'chargeMap 集合',
                  tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                  td: [
                    { info1: '小时', info2: '是', info3: 'Integer', info4: '小时字段' },
                  ]
                },{
                  titleName: 'chargeMap小时数据',
                  tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                  td: [
                    { info1: 'fee', info2: '是', info3: 'Integer', info4: '收费金额（分）' },
                  ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/park/getParkYdtOtherCarTypeChargeInfo.vue